var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"dark":_vm.env === 'development'}},[_c(_vm.layout,{tag:"component"},[_c('router-view'),_c('footer',{staticStyle:{"margin-top":"80px"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }